function checkIfClickedInsideElement(element, clickedElement) {
    
    if(!element || !clickedElement){
        return;
    }

    do {
        if (clickedElement == element) {
            //clicked inside de element
            return true;
        }

        //Go to next element
        clickedElement = clickedElement.parentNode;
    } while (clickedElement);

}

export {checkIfClickedInsideElement};


// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/core/clickEventValidator.js